import { Component, OnInit } from '@angular/core';
import { Router, UrlSerializer } from '@angular/router';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IFileDownload, IExam } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-exam-examiners-marking-report',
  templateUrl: './exam-question-analysis-excel.component.html',
  styleUrls: ['./exam-question-analysis-excel.component.scss']
})
export class ExamQuestionAnalysisExcelComponent implements OnInit {
  skipImportCandidateData = false;

  exportedFile: IFileDownload = {
    fileName: '',
    size: 0,
    extension: '',
    file: undefined
  };
  exam: IExam = examDefault;
  constructor(private popoverRef: PopoverRef<ExamQuestionAnalysisExcelComponent>,
    private examService: ExamService, private router: Router,
    private snackBar: SnackbarService, private serializer: UrlSerializer) { }

  ngOnInit() {
  }

  close() {
    this.popoverRef.close();
  }

  async generateReport() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
      // const reportTree = this.router.createUrlTree([], { queryParams: { "examId": this.exam.id,} });
      // let params = this.serializer.serialize(reportTree).split('?', 2)[1];
      await this.examService.getQuestionAnalysisExcel(this.exam.id).then((s: IFileDownload) => {
        if(s){
          this.snackBar.success('Report Successfull');
          this.exportedFile = s;
        }
      })
    }
  }

}
